import { FaFilePdf } from 'react-icons/fa';
import { useState, useEffect, useRef } from 'react';
import { getDownloadURL } from 'firebase/storage';
import { usePdfContext } from '../PdfContext';

function FileSelector({ fileList, setLoadedPdf, closeWind }) {
    const [currentPdf, setCurrentPdf] = useState(null);
    const pdfObj = usePdfContext();
    const { loaderObj, isAndroid } = pdfObj;
    const fileViewerRef = useRef(null);

    const downloadFile = async (file) => {
        if (currentPdf === file) return;

        setCurrentPdf(file);
        loaderObj.setter(true);
        loaderObj.contSetter('Loading PDF file...');
        pdfObj.setter(file);

        try {
            const url = await getDownloadURL(file);
            setLoadedPdf(url);
        } catch (error) {
            console.error('Error downloading file:', error);
            loaderObj.contSetter('Error loading PDF file');
            setTimeout(() => {
                loaderObj.setter(false);
                loaderObj.contSetter('');
            }, 3000);
        } finally {
            loaderObj.setter(false);
            loaderObj.contSetter('');
            closeWind(null); // Automatically close menu after file selection
        }
    };

    useEffect(() => {
        const handlePagesInit = () => {
            loaderObj.setter(false);
            loaderObj.contSetter('');
        };

        document.addEventListener('pagesinit', handlePagesInit);
        return () => document.removeEventListener('pagesinit', handlePagesInit);
    }, [loaderObj]);

    useEffect(() => {
        if (fileList.length > 0 && fileViewerRef.current) {
            fileViewerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [fileList]);

    return (
        <div className={`selector-ctn${isAndroid ? ' android' : ''}`}>
            <div className="file-selector-header">
                <button className="btn close-btn" style={{ width: 'calc(200% - 10px)', margin: '10px' }} onClick={() => closeWind(null)}>
                    CLOSE MENU
                </button>
            </div>
            <div className="file-viewer" ref={fileViewerRef}>
                {fileList.map((file) => (
                    <div
                        key={file?.fullPath}
                        className={`file-obj${currentPdf === file ? ' active' : ''}`}
                        onClick={() => downloadFile(file)}
                    >
                        <FaFilePdf className="file-icon" />
                        <div className="file-name">
                            {file?.name?.length > 15
                                ? `${file.name.substring(0, 15)}...`
                                : file?.name}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default FileSelector;
